"use client";

import { useLocale } from "next-intl";
import { usePostHog } from "posthog-js/react";
import { Link, usePathname } from "@/i18n/navigation";
import { cn } from "@/lib/utils";

export function LangSwitcher() {
  const locale = useLocale();
  const pathname = usePathname();
  const posthog = usePostHog();

  return (
    <div className="flex rounded-full border border-line bg-surface-dim p-0.5">
      <Link
        href={pathname}
        locale="ru"
        onClick={() => posthog?.capture("lang_switched", { from: locale, to: "ru" })}
        className={cn(
          "rounded-full px-3 py-1 text-xs font-medium transition-colors",
          locale === "ru"
            ? "bg-surface-mute text-ink"
            : "text-ink-mute hover:text-ink"
        )}
      >
        RU
      </Link>
      <Link
        href={pathname}
        locale="en"
        onClick={() => posthog?.capture("lang_switched", { from: locale, to: "en" })}
        className={cn(
          "rounded-full px-3 py-1 text-xs font-medium transition-colors",
          locale === "en"
            ? "bg-surface-mute text-ink"
            : "text-ink-mute hover:text-ink"
        )}
      >
        EN
      </Link>
    </div>
  );
}
